import { yupResolver } from '@hookform/resolvers/yup';
import { cloneDeep } from 'lodash';

export default (validate) => async (values, context, options) => {
    const schema = validate(values, context);
    return yupResolver(schema)(cloneDeep(values), context, options);
};
